import clsx from "clsx";
import React from "react";

import { WYSIWYG, WYSIWYGProps } from "@fronterahealth/frontera-ui-components";

export const ChatWYSIWYG: React.FC<WYSIWYGProps> = ({ displayOnlyMode, ...props }) => {
  return (
    // Note: These custom tailwind/css classes are for chat specific styling of the WYSIWYG component. If edited, please verify all chat components still render as expected
    <div
      className={clsx(
        "[&_.group]:pr-0! [&_.ql-editor]:[scrollbar-width:none] [&::-webkit-scrollbar]:[&_.ql-editor]:hidden [&_.ql-toolbar]:bg-white [&_.ql-toolbar]:z-10 [&_.ql-toolbar]:w-fit! [&_.ql-toolbar]:border-0! [&_.ql-toolbar]:mx-2! [&_.ql-container]:border-0! flex-1 min-w-0 overflow-hidden",
        !displayOnlyMode && "[&_.ql-editor]:max-h-[40vh] [&_.ql-editor]:overflow-y-auto",
      )}
    >
      <WYSIWYG displayOnlyMode={displayOnlyMode} {...props} />
    </div>
  );
};
